/// <amd-module name="TFS/Admin/Common/RestClient/ProjectSettings" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\client\adminengagement\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as ProjectSettings from "../Contracts/ProjectSettings";

export interface IProjectSettingsRestClient extends IVssRestClient {
    /**
     * @param project - Project ID or project name
     */
    getProjectAdminString(project: string): Promise<ProjectSettings.AdminModel>;
}

class ProjectSettingsRestClient extends RestClientBase implements IProjectSettingsRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param project - Project ID or project name
     */
    public async getProjectAdminString(
        project: string
        ): Promise<ProjectSettings.AdminModel> {

        return this.beginRequest<ProjectSettings.AdminModel>({
            apiVersion: "5.1-preview.1",
            routeTemplate: "{project}/_apis/ProjectSettings/Project",
            routeValues: {
                project: project
            }
        });
    }

}

export const ProjectSettingsClientName = "IProjectSettingsRestClient";

export function getProjectSettingsClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IProjectSettingsRestClient {
    return pageContext.getRestClient<IProjectSettingsRestClient>(ProjectSettingsClientName, options);
}

RestClients.add(ProjectSettingsClientName, { 
    factory: ProjectSettingsRestClient
});
